module.exports = __webpack_public_path__ + "img/blueballon.a349e88b.png";